import DatabaseBackupContainer from "../../container/admin/database-backup";

const DatabaseBackup = () => {
    return <DatabaseBackupContainer />;
};

export default DatabaseBackup;
